/**
 * Router state the email status toast passes when it opens Review
 * (YAR-480 AC7): open at the top and highlight the run's cards — even when
 * the parent is already on Review.
 */
export interface ReviewHighlightState {
  highlightEmailIds: string[];
}

/** How long the highlighted cards stay marked. */
export const REVIEW_HIGHLIGHT_MS = 4_000;

export function readReviewHighlight(state: unknown): string[] {
  if (typeof state !== 'object' || state === null) return [];
  const ids = (state as { highlightEmailIds?: unknown }).highlightEmailIds;
  return Array.isArray(ids)
    ? ids.filter((id): id is string => typeof id === 'string')
    : [];
}
